import React, { useEffect, useState } from "react";
import "./Steps.scss";
import { Steps, Button, Form, Input, Select } from "antd";
import axios from "axios";
import { useMediaQuery } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import Education from "./stepsForm/Education";
import Experiance from "./stepsForm/Experiance";
import { APIV3 } from "../../../utils/customAxios";
import {
  getDegreesByInstituteWithYearOfCompletion,
  getUniqueObjectsByKey,
} from "../../../helpers/utilityHelper";
import Cookies from "js-cookie";
import Loader from "../../../uiComponents/loader/Loader";
import { isMobile } from "react-device-detect";
import { toast, ToastContainer } from "react-toastify";

const { Step } = Steps;
const { Option } = Select;
const StepTwo = ({
  moveToConsultation,
  setAbout,
  setQualification,
  setConsultation,
  setCurrentStep,
  setListner,
}) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [currentStepTwo, setCurrentStepTwo] = useState(0);
  const [form] = Form.useForm();
  const [educationForm] = Form.useForm();
  const [experienceForm] = Form.useForm();
  const [profileData, setProfileData] = useState({});
  const [rowCount, setRowCount] = useState(1);
  const [firstSubmissionLoader, setFirstSubmissionLoader] = useState(false);
  const [secondSubmissionLoader, setSecondSubmissionLoader] = useState(false);
  const [apiDegrees, setApiDegrees] = useState([]);
  const [rowCertificate, setRowCertificate] = useState(1);
  const [experienceRowCount, setExperienceRowCount] = useState(1);

  const duplicateRow = () => {
    setRowCount(rowCount + 1);
  };
  const deleteeRow = () => {
    setRowCount(rowCount - 1);
  };

  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(
    Array.from({ length: experienceRowCount }, () => false)
  );

 const duplicateExperienceRow = () => {
  setExperienceRowCount((prev) => prev + 1);
  setIsCurrentlyWorking((prev) => [...prev, false]); // 🧠 Add false for the new row
};

const deleteExperienceRow = () => {
  setExperienceRowCount((prev) => {
    if (prev > 1) {
      setIsCurrentlyWorking((prevState) => prevState.slice(0, prev - 1));
      return prev - 1;
    }
    return prev;
  });
};

  const duplicateRowCertificate = () => {
    setRowCertificate(rowCertificate + 1);
  };

  const deleteRowCertificate = () => {
    setRowCertificate(rowCertificate - 1);
  };

  useEffect(() => {
    APIV3.get(`/doctor/profile-details?education=1`).then((res) => {
      if (res?.status === 200) {
        setProfileData(res?.data?.data);
        let degrees = [];
        res?.data?.data?.doctor_education?.forEach((item) => {
          degrees.push(item?.degree_id);
        });
        setApiDegrees(degrees);
      }
    });
  }, []);

  useEffect(() => {
    APIV3.get(`/doctor/profile-details?experiences=1`).then((res) => {
      if (res?.status == 200) {
        setProfileData(res?.data?.data);
      }
    });
  }, []);

  useEffect(() => {
    APIV3.get(`/doctor/profile-details?certification=1`).then((res) => {
      if (res?.status == 200) {
        setProfileData(res?.data?.data);
      }
    });
  }, []);
  //show prefilled education data

const normalizeMonth = (val) => {
  const monthNumberToName = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  if (typeof val === "number") {
    return monthNumberToName[val] || null;
  }

  // Check if val is a string that looks like a number
  if (!isNaN(val)) {
    const result = monthNumberToName[Number(val)] || null;
    return result;
  }

  // Valid month name like "April"
  return val;
};


  useEffect(() => {
    if (Object.keys(profileData).length > 0) {
      const doctorEducation = profileData?.doctor_education;

      if (doctorEducation?.length > 0) {
        const degreesByInstituteWithYearOfCompletion =
          getDegreesByInstituteWithYearOfCompletion(doctorEducation);

        setRowCount(degreesByInstituteWithYearOfCompletion.length);

        for (
          let i = 0;
          i < degreesByInstituteWithYearOfCompletion.length;
          i++
        ) {
          form.setFieldsValue({
            [`degree${i + 1}`]: degreesByInstituteWithYearOfCompletion[i]?.map(
              (item) => {
                return item?.degree;
              }
            ),
            [`institute${i + 1}`]:
              degreesByInstituteWithYearOfCompletion?.[i]?.[0]?.institute,
            [`completion${i + 1}`]:
              degreesByInstituteWithYearOfCompletion?.[i]?.[0]
                ?.yearOfCompletion,
          });
        }
      }

      const doctorExperiences = profileData?.doctor_experiences;
      if (doctorExperiences?.length > 0) {
        setExperienceRowCount(doctorExperiences?.length);
        const workingStatuses = doctorExperiences.map(
    (exp) => exp?.is_currently_working == 1
  );
  setIsCurrentlyWorking(workingStatuses);
        for (let i = 0; i < doctorExperiences?.length; i++) {
          form.setFieldsValue({
            [`designation${i + 1}`]: doctorExperiences?.[i]?.position_id,
            [`institute_exp${i + 1}`]: doctorExperiences?.[i]?.institute_id,
            [`startyear${i + 1}`]: doctorExperiences?.[i]?.start_year,
            [`endyear${i + 1}`]: doctorExperiences?.[i]?.end_year,
            // [`startmonth${i + 1}`]: doctorExperiences?.[i]?.start_month,
            // [`endmonth${i + 1}`]: doctorExperiences?.[i]?.end_month,
             [`startmonth${i + 1}`]: normalizeMonth(doctorExperiences?.[i]?.start_month),
  [`endmonth${i + 1}`]: normalizeMonth(doctorExperiences?.[i]?.end_month),

          });
        }
      }

      const doctorCertification = profileData?.doctor_certification;

      if (doctorCertification?.length > 0) {
        setRowCertificate(doctorCertification?.length);

        for (let i = 0; i < doctorCertification?.length; i++) {
          form.setFieldsValue({
            [`membershipcertificate${i + 1}`]:
              doctorCertification?.[i]?.certification_id,
          });
        }
      }
    }
  }, [JSON.stringify(profileData)]);

  // useEffect(() => {
  //   if (Object.keys(profileData).length > 0) {
  //     const doctorEducation = profileData?.doctor_education;

  //     if (doctorEducation?.length > 0) {
  //       const degreesByInstituteWithYearOfCompletion =
  //         getDegreesByInstituteWithYearOfCompletion(doctorEducation);

  //       setRowCount(degreesByInstituteWithYearOfCompletion.length);

  //       for (
  //         let i = 0;
  //         i < degreesByInstituteWithYearOfCompletion.length;
  //         i++
  //       ) {
  //         educationForm.setFieldsValue({
  //           [`degree${i + 1}`]: degreesByInstituteWithYearOfCompletion[i]?.map(
  //             (item) => {
  //               return item?.degree;
  //             }
  //           ),
  //           [`institute${i + 1}`]:
  //             degreesByInstituteWithYearOfCompletion?.[i]?.[0]?.institute,
  //           [`completion${i + 1}`]:
  //             degreesByInstituteWithYearOfCompletion?.[i]?.[0]
  //               ?.yearOfCompletion,
  //         });
  //       }
  //     }
  //   }
  // }, [JSON.stringify(profileData)]);

  // show prefilled experiences data

  useEffect(() => {
    if (Object.keys(profileData).length > 0) {
      // const doctorExperiences = profileData?.doctor_experiences;
      // if (doctorExperiences?.length > 0) {
      //   setExperienceRowCount(doctorExperiences?.length);

      //   for (let i = 0; i < doctorExperiences?.length; i++) {
      //     experienceForm.setFieldsValue({
      //       [`designation${i + 1}`]: doctorExperiences?.[i]?.position_id,
      //       [`institute${i + 1}`]: doctorExperiences?.[i]?.institute_id,
      //       [`startyear${i + 1}`]: doctorExperiences?.[i]?.start_year,
      //       [`endyear${i + 1}`]: doctorExperiences?.[i]?.end_year,
      //       [`startmonth${i + 1}`]: doctorExperiences?.[i]?.start_month,
      //       [`endmonth${i + 1}`]: doctorExperiences?.[i]?.end_month,
      //     });
      //   }
      // }

      // const doctorCertification = profileData?.doctor_certification;

      // if (doctorCertification?.length > 0) {
      //   setRowCertificate(doctorCertification?.length);

      //   for (let i = 0; i < doctorCertification?.length; i++) {
      //     experienceForm.setFieldsValue({
      //       [`membershipcertificate${i + 1}`]:
      //         doctorCertification?.[i]?.certification_id,
      //     });
      //   }
      // }
    }
  }, [JSON.stringify(profileData)]);

  const handleExperienceSubmit = async (e, save) => {
    try {
      await form.validateFields();
      const values2 = form.getFieldsValue();
      let educ = [];

      for (let i = 1; i <= rowCount; i++) {
        educ.push({
          degree: (typeof values2[`degree${i}`] === "string" || typeof values2[`degree${i}`] === 'number') ? values2[`degree${i}`] : values2[`degree${i}`]?.[0],
          institute: values2["institute" + i],
          year_of_completion: values2["completion" + i],
        });
      }

      let exp = [];
      for (let i = 1; i <= experienceRowCount; i++) {
        exp.push({
          position: values2["designation" + i],
          institute: values2["institute_exp" + i],
          start_year: values2["startyear" + i],
          end_year: values2["endyear" + i],
          start_month: values2["startmonth" + i],
          end_month: values2["endmonth" + i],
          is_currently: isCurrentlyWorking[i - 1],
        });
      }

      let certification = [];

      for (let i = 1; i <= rowCertificate; i++) {
        certification.push(values2["membershipcertificate" + i]);
      }

      let payload = {};

      if (exp?.length > 0) {
        payload.exp = exp;
      }
      if (educ?.length > 0) {
        payload.educ = educ;
      }
      if (typeof certification[0] !== "undefined") {
        payload.certification = certification;
      }



      // let payload = {
      //     exp: exp,
      //     certification: certification
      // };

      try {
        setSecondSubmissionLoader(true);
        const response = await APIV3.post(
          `/doctor/detail`,
          payload
        );
        setSecondSubmissionLoader(false);
        if (response?.status == 200) {
          Cookies.set("pageStatus", "consultation");
          moveToConsultation();
          setListner((prevStep) => !prevStep);
          if (isMobile) {
            toast.success("Educations & Experiences Submit Successfully.");
            setCurrentStep((prevStep) => prevStep + 1);
            setQualification(false);
            setConsultation(true);
          };
          setQualification(false);
          setConsultation(true);
        } else {
          toast.success(response?.data?.message);
        }
      } catch (error) {
        console.error(error);
        setSecondSubmissionLoader(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePrev = () => {
    setCurrentStepTwo((prevStep) => prevStep - 1);
  };

  const handlePrevTwo = () => {
    setAbout(true);
    setQualification(false);
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFormSubmit = (values) => {
    // Submit the form data to the server using axios or your preferred method
    axios
      .post("/api/submit-form", values)
      .then((response) => {
        // Handle the response
      })
      .catch((error) => {
        // Handle the error
        console.error(error);
      });
  };

  return (
    <>
      {(firstSubmissionLoader || secondSubmissionLoader) && (
        <>
          <Loader />
        </>
      )}
      <div className="steps_form">
        {/* {!isMobile ? (
          <>
            <Steps current={currentStepTwo} className="d-none">
              <Step key="education" title="Education" />
              <Step key="experience" title="Experience" />
            </Steps>
          </>
        ) : null} */}
        {/* <div style={{ marginTop: 16 }} className="bt-01"> */}
          {/* {!isMobile ? (
            currentStepTwo === 0 && (
              <> */}
                <Form form={form} onFinish={handleExperienceSubmit} className={`${!isMobile ? 'borderMiddle' : ''} steptwo bt-01`} style={{ marginTop: 16 }}>
                  <Row style={{ height: !isMobile  ? '800px' : '' }}>
                    <Col lg={6} style={{ height: !isMobile ? '700px': '' }} className={`${!isMobile ? 'scrollable' : ''}`}>
                      <div className={`${!isMobile ? 'pe-3': ''}`}>
                        <Education
                          rowCount={rowCount}
                          duplicateRow={duplicateRow}
                          deleteeRow={deleteeRow}
                          apiDegrees={apiDegrees}
                          form={form}
                        />
                      </div>
                    </Col>
                    <Col lg={6} style={{ height: !isMobile ? '700px' : '' }} className={`${!isMobile ? 'scrollable' : ''}`}>
                      <div className={`${!isMobile ? 'ps-3': ''}`}>
                        <Experiance
                          experienceForm={experienceForm}
                          experienceRowCount={experienceRowCount}
                          duplicateExperienceRow={duplicateExperienceRow}
                          deleteExperienceRow={deleteExperienceRow}
                          rowCertificate={rowCertificate}
                          duplicateRowCertificate={duplicateRowCertificate}
                          deleteRowCertificate={deleteRowCertificate}
                          form={form}
                          isCurrentlyWorking={isCurrentlyWorking}
                          setIsCurrentlyWorking={setIsCurrentlyWorking}
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
                <div className="buttons_box">
                  <div className="box_buttons">
                    <Button
                      disabled={firstSubmissionLoader}
                      onClick={(e) => handleExperienceSubmit(e, true)}
                      type="primary"
                      className="btn btn-01 bg-light1 me-3"
                    >
                      Save
                    </Button>
                    <Button
                      disabled={firstSubmissionLoader}
                      type="primary"
                      onClick={handleExperienceSubmit}
                      className="btn btn-01  bg-dark1"
                    >
                      Next
                    </Button>
                  </div>
                </div>

              {/* </>
            )
          ) : ( */}
            {/* <Form form={form} onFinish={handleExperienceSubmit}>
              <Education
                rowCount={rowCount}
                duplicateRow={duplicateRow}
                deleteeRow={deleteeRow}
                apiDegrees={apiDegrees}
                form={form}
              /> */}
              {/* <div className="buttons_box">
                                <div className="box_buttons">
                                    <Row>
                                        <Col lg={6} md={6} className="text-start">
                                            {!isMobile ? (
                                                <>
                                                    <Button type="primary" onClick={handlePrevTwo} className="btn btn-01 bg-light1 me-3" >
                                                        Back to About You
                                                    </Button>
                                                </>
                                            ) : null}
                                        </Col>
                                        <Col lg={6} md={6} className="text-end">
                                            <Button disabled={firstSubmissionLoader} onClick={(e) => handleNext(e, true)} type="primary" className="btn btn-01 bg-light1 me-3" >
                                                Save
                                            </Button>
                                            <Button disabled={firstSubmissionLoader} type="primary" onClick={handleNext} className="btn btn-01  bg-dark1">
                                                Next
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </div> */}
            {/* </Form> */}
          {/* )} */}

          {/* {!isMobile ? (
            currentStepTwo === 1 && (
              <Form form={experienceForm} onFinish={handleExperienceSubmit}>
                <Experiance
                  experienceForm={experienceForm}
                  // experienceForm={experienceForm}
                  experienceRowCount={experienceRowCount}
                  duplicateExperienceRow={duplicateExperienceRow}
                  deleteExperienceRow={deleteExperienceRow}
                  rowCertificate={rowCertificate}
                  duplicateRowCertificate={duplicateRowCertificate}
                  deleteRowCertificate={deleteRowCertificate}
                  form={experienceForm}
                  isCurrentlyWorking={isCurrentlyWorking}
                  setIsCurrentlyWorking={setIsCurrentlyWorking}
                />

                <div className="buttons_box">
                  <div className="box_buttons">
                    <Button
                      disabled={secondSubmissionLoader}
                      onClick={(e) => handleExperienceSubmit(e, true)}
                      type="primary"
                      style={{ marginRight: 8 }}
                      className="btn btn-01 bg-light1"
                    >
                      Save
                    </Button>
                    <Button
                      type="primary"
                      disabled={secondSubmissionLoader}
                      className="btn btn-01 bg-dark1 ss"
                      onClick={handleExperienceSubmit}
                    >
                      Next
                    </Button>
                    <Row className=" d-none">
                      <Col lg={6} md={6} className="text-start">
                        <Button
                          className="btn  btn-01 bg-light1"
                          onClick={handlePrev}
                        >
                          Back
                        </Button>
                      </Col>
                      <Col lg={6} md={6} className="text-end">

                      </Col>
                    </Row>
                  </div>
                </div>
              </Form>
            )
          ) : (
            <>
              <h2 className="mt-3">Experience</h2>
              <Form form={experienceForm} onFinish={handleExperienceSubmit}>
                <Experiance
                  experienceForm={experienceForm}
                  experienceRowCount={experienceRowCount}
                  duplicateExperienceRow={duplicateExperienceRow}
                  deleteExperienceRow={deleteExperienceRow}
                  rowCertificate={rowCertificate}
                  duplicateRowCertificate={duplicateRowCertificate}
                  deleteRowCertificate={deleteRowCertificate}
                  form={experienceForm}
                  isCurrentlyWorking={isCurrentlyWorking}
                  setIsCurrentlyWorking={setIsCurrentlyWorking}
                />

                <div className="buttons_box">
                  <div className="box_buttons">
                    <Row>
                      <Col lg={6} md={6} className="text-center">
                        <Button
                          disabled={firstSubmissionLoader}
                          onClick={(e) => handleExperienceSubmit(e, true)}
                          type="primary"
                          className="btn btn-01 bg-light1 me-3"
                        >
                          Save
                        </Button>
                        <Button
                          disabled={firstSubmissionLoader}
                          type="primary"
                          onClick={handleExperienceSubmit}
                          className="btn btn-01  bg-dark1"
                        >
                          Next
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Form>
            </>
          )} */}
        {/* </div> */}
      </div>
      {/* <div className="toast_blue width_toast">
        <ToastContainer />
      </div> */}
    </>
  );
}

export default StepTwo;
